/**
 * 전화번호 포맷팅 유틸리티
 * 
 * 규칙:
 * 1. 0으로 시작하는 경우:
 *    - 0##-####-#### (11자리)
 *    - 0#-###-#### (9자리)
 *    - 0##-###-#### (10자리)
 *    - 0#-####-#### (10자리)
 * 2. 1로 시작하는 경우:
 *    - 1###-#### (8자리)
 * 3. 그 외: 숫자만 표시
 */
export const formatPhoneNumber = (phone: string | undefined | null): string => {
  if (!phone) return '-';
  
  // 숫자만 추출
  const digits = phone.replace(/[^0-9]/g, '');
  
  if (digits.startsWith('0')) {
    if (digits.length === 11) {
      // 0##-####-####
      return digits.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    } else if (digits.length === 9) {
      // 0#-###-####
      return digits.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
    } else if (digits.length === 10) {
      // 0##-###-#### 또는 0#-####-####
      // 한국 지역번호/휴대폰 체계상 보통 02(2자리) 또는 010, 031 등(3자리)으로 시작
      if (digits.startsWith('02')) {
        // 02-####-#### (0#-####-####)
        return digits.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
      } else {
        // 0##-###-####
        return digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
      }
    }
  } else if (digits.startsWith('1')) {
    if (digits.length === 8) {
      // 1###-####
      return digits.replace(/(\d{4})(\d{4})/, '$1-$2');
    }
  }
  
  return digits;
};

/**
 * 카테고리 코드에 따른 명칭 반환
 */
export const getCategoryLabel = (category: string | undefined | null): string => {
  if (!category) return '-';
  
  switch (category.toUpperCase()) {
    case 'CLIENT':
      return '고객';
    case 'VIP':
      return 'VIP';
    case 'INNER':
      return '내부 관계자';
    default:
      return category;
  }
};

/**
 * 날짜 포맷팅 (YYYY-MM-DD HH:mm:ss)
 */
export const formatDate = (dateString: string | undefined | null): string => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } catch (e) {
    return '-';
  }
};

/**
 * 재생 시간을 MM:SS 형식으로 변환 (초 단위 입력)
 */
export const formatDuration = (seconds: number | undefined | null): string => {
  if (seconds === undefined || seconds === null) return '0:00';
  const min = Math.floor(seconds / 60);
  const sec = Math.floor(seconds % 60);
  return `${min}:${sec.toString().padStart(2, '0')}`;
};
